// extracted by mini-css-extract-plugin
export default {"page":"callback_page__STYc+","text":"callback_text__tp3AC"};